module.exports = __webpack_public_path__ + "img/shequ-2.a5a33491.png";